import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    {
      path: '/tarjas',
      name: 'tarjas',
      component: () => import( './views/Tarjas.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/crud/:name?',
      name: 'crud',
      component: () => import( './views/crud.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/asistencias',
      name: 'asistencias',
      component: () => import( './views/asistencia.vue'),
      meta: {
        requiresAuth: true
      }
  },
    {
      path: '/remuneraciones',
      name: 'remuneraciones',
      component: () => import( './views/Remuneraciones.vue'),
      meta: {
        requiresAuth: true
      }
  },
  {
      path: '/analisis',
      name: 'analisis',
      component: () => import( './views/Analisis.vue'),
      meta: {
        requiresAuth: true
      }
  },
  {
    path: '/analisisPresupuesto',
      name: 'analisisPresupuesto',
      component: () => import( './views/AnalisisPresupuesto.vue'),
      meta: {
        requiresAuth: true
      }
    },
  {
    path: '/analisisComparativo',
      name: 'analisisComparativo',
      component: () => import( './views/AnalisisComparativo.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/presupuestos',
      name: 'presupuestos',
      component: () => import( './views/Presupuestos.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      meta:{
        drawer: false,
        withTabs: false
      },
      component: () => import( './views/Login.vue')
    },

    { path: '/',            redirect: '/tarjas' },
    { path: "/index.html",  redirect: "/" }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      console.log("next isLoggedIn route.js");
      next();
      return
    }
    console.log("next to login Router.js");
    next('/login');
  } else {
    console.log("next Router.js");
    next();
  }
})


export default router;
